import React, { ReactElement, useEffect, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { ArtData } from '@/database/art'
import DetailsPanel from '@/components/details/details/DetailsPanel'
import TokenomicsPanel from '@/components/details/tokenomics/TokenomicsPanel'
import VotesClaimsPanel from '@/components/details/votesclaims/VotesClaimsPanel'
import EmptyPanel from '@/components/details/empty/EmptyPanel'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import ChatPanel from '@/components/panels/ChatPanel'
import HistoryPanel from '@/components/details/history/HistoryPanel'
import WalletsPanel from '@/components/details/wallets/WalletsPanel'

const TABS = 7

const calculateSlidesPerView = () => {
    const screenWidth = window.innerWidth
    if (screenWidth >= 714) return TABS
    // Adjust the scaling logic below as needed
    return Math.max(1, Math.floor(screenWidth / 108)) // Example scaling logic
}

const DetailsTabs = ({ artData, tabName }: { artData: ArtData; tabName: string }): ReactElement => {
    const [activeIndex, setActiveIndex] = useState(0)
    const [slidesPerView, setSlidesPerView] = useState(7)

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' })

        const handleResize = () => {
            const slidesPerViewNeeded = calculateSlidesPerView()
            if (slidesPerViewNeeded !== slidesPerView) {
                setSlidesPerView(slidesPerViewNeeded)
            }
        }
        handleResize()

        window.addEventListener('resize', handleResize, false)
        return () => {
            window.removeEventListener('resize', handleResize, false)
        }
    }, [])

    return (
        <div>
            <Tabs defaultFocus={false} selectedIndex={activeIndex} onSelect={() => {}}>
                <Swiper
                    slidesPerView={slidesPerView}
                    spaceBetween={0}
                    freeMode={true}
                    onClick={(index) => {
                        setActiveIndex(index.clickedIndex)
                    }}
                    modules={[FreeMode, Navigation]}
                    navigation={slidesPerView < TABS}
                >
                    <TabList>
                        <SwiperSlide className="no-border">
                            <Tab>Your&nbsp;Comments</Tab>
                        </SwiperSlide>
                        <SwiperSlide className="no-border">
                            <Tab>Details</Tab>
                        </SwiperSlide>
                        <SwiperSlide className="no-border">
                            <Tab>Tokenomics</Tab>
                        </SwiperSlide>
                        <SwiperSlide className="no-border">
                            <Tab>Wallets</Tab>
                        </SwiperSlide>
                        <SwiperSlide className="no-border">
                            <Tab>Votes/Claims</Tab>
                        </SwiperSlide>
                        <SwiperSlide className="no-border">
                            <Tab>History</Tab>
                        </SwiperSlide>
                        <SwiperSlide className="no-border">
                            <Tab>Activity</Tab>
                        </SwiperSlide>
                    </TabList>
                </Swiper>
                <div>
                    <TabPanel>
                        <ChatPanel artData={artData} tabName={tabName} />
                    </TabPanel>
                    <TabPanel>
                        <DetailsPanel artData={artData} tabName={tabName} />
                    </TabPanel>
                    <TabPanel>
                        <TokenomicsPanel artData={artData} tabName={tabName} />
                    </TabPanel>
                    <TabPanel>
                        <WalletsPanel artData={artData} tabName={tabName} />
                    </TabPanel>
                    <TabPanel>
                        <VotesClaimsPanel artData={artData} tabName={tabName} />
                    </TabPanel>
                    <TabPanel>
                        <HistoryPanel artData={artData} tabName={tabName} />
                    </TabPanel>
                    <TabPanel>
                        <EmptyPanel artData={artData} />
                    </TabPanel>
                </div>
            </Tabs>
        </div>
    )
}

DetailsTabs.whyDidYouRender = true

export default DetailsTabs
